/* eslint-disable max-len */
// CONSTANTS are all caps.
const NS = 'WelcomeBannerModal';
const CLS = 'welcomeBannerModal';
const REGION_STORAGE_NAME = `awi.${CLS}.region`;

export class WelcomeBannerModal {
	constructor(el) {
		this.el = el;
		this.$el = $(el);

		this.onModalOpen();
		this.checkLocalStorage();
		this.checkHash();
		this.handleLink();
	}

	checkLocalStorage() {
		let region = localStorage.getItem(REGION_STORAGE_NAME);

		// if there is local storage doesn't have value, it will trigger modal
		if (!region) {
			this.$el.modal('show');
		} else {
			// compare the saved "link" from local storage to the current url
			// if not match, it will redirect (modify the url using from the saved one)
			region = JSON.parse(region);
			let currentUrl = window.location.href;
			let baseAddress = this.$el.data('baseaddress');
			let pathName = currentUrl.replace(baseAddress, '');
			if (baseAddress !== region.link) {
				let newUrl = `${region.link}${pathName}`;
				window.location.href = newUrl;
			}
		}
	}

	handleLink() {
		this.$el.find(`.${CLS}-link`).on('click', (e) => {
			let $link = $(e.target);

			if (!$link.hasClass(`${CLS}-link`)) {
				$link = $link.parent(`.${CLS}-link`);
			}

			let param = {
				code: $link.data('code'),
				link: $link.attr('href'),
				name: $link.find(`.${CLS}-countryName`).text(),
			};

			window.localStorage.setItem(REGION_STORAGE_NAME, JSON.stringify(param));
		});
	}

	// trigger modal using hash on url, eg: wool4school.com#welcomeBannerModal
	checkHash() {
		let urlHashString = window.location.hash;
		let urlHash = (urlHashString.substr(0, (urlHashString + '?').indexOf('?')));
		if (!urlHash) return;

		let $modal = $(urlHash);
		if ($modal.length !== 0 && $modal.hasClass('modal')) {
			$modal.modal('show');
		}
	}

	onModalOpen() {
		this.$el.on('show.bs.modal', () => {
			$('html').css('overflowY', 'hidden');
		});
	}
}
